import React from "react";
import { CheckIcon, LockIcon } from "lucide-react";
import { images } from "../../data/content";
import { CTAButton } from "../CTAButton";
import { OfferUrgency } from "../OfferUrgency";
const stack = [{
  title: "Complete Lipo Revision Case Atlas™ System",
  sub: "6 premium volumes",
  value: "$97"
}, {
  title: "5 Exclusive Bonuses",
  sub: "30 educational cases + review tools + cards + challenge",
  value: "$197"
}];
const perks = ["Lifetime digital access", "Instant download", "No monthly subscription", "No recurring fees", "7-day guarantee"];
export function Offer() {
  return <section id="offer" className="bg-ink px-4 py-16 text-white" data-id="element-188" data-mp="3juqepsvolv8g">
      <div className="mx-auto max-w-xl" data-id="element-189" data-mp="3jxcuugwn1j2a">
        <p className="text-center text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-190" data-mp="3nx3k2g6inr4p">Special launch offer</p>
        <h2 className="mt-2 text-center font-serif text-[30px] font-bold leading-tight sm:text-4xl" data-id="element-191" data-mp="3swzrkpefa0p0">
          Here’s everything you’ll receive today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white text-ink" data-id="element-192" data-mp="1kl89kvaivda9">
          <img src={images.product} alt="Lipo Revision Case Atlas full bundle" className="block w-full bg-cream" data-id="element-193" data-mp="1kj3v5jezyvvq" />
          <div className="p-5 sm:p-7" data-id="element-194" data-mp="1bks45ga7xw2r">
            <ul className="divide-y divide-sand" data-id="element-195" data-mp="1bltlu3lqpgtg">
              {stack.map(s => <li key={s.title} className="flex items-start justify-between gap-4 py-3.5" data-id="element-196" data-mp="16mgzdjys6bre">
                  <div data-id="element-197" data-mp="23c7qd97v5gsg">
                    <p className="text-[16px] font-bold leading-snug" data-id="element-198" data-mp="23aod7rhi7luw">{s.title}</p>
                    <p className="text-[14px] text-muted" data-id="element-199" data-mp="1zbfgcdr637v4">{s.sub}</p>
                  </div>
                  <span className="text-[17px] font-bold text-red-600 line-through" data-id="element-200" data-mp="1uiuovivqh6ur">{s.value}</span>
                </li>)}
              <li className="flex items-center justify-between py-3.5" data-id="element-201" data-mp="1pkb3bjl1xx2x">
                <p className="text-[14px] font-extrabold uppercase tracking-wide" data-id="element-202" data-mp="2n10bdv0lhvkr">Total perceived value</p>
                <span className="text-[20px] font-extrabold text-red-600 line-through" data-id="element-203" data-mp="2i8gpmarr7u4v">$294</span>
              </li>
            </ul>

            <div className="mt-4 rounded-2xl bg-sand px-4 py-6 text-center" data-id="element-204" data-mp="317k2pd0quh9u">
              <p className="text-[14px] font-bold uppercase tracking-wide text-navy" data-id="element-205" data-mp="364290hbq2noa">Today, get the complete system for only</p>
              <p className="mt-1 font-serif text-[84px] font-extrabold leading-none text-ctadark" data-id="element-206" data-mp="2sbchxyhc6skb">$27</p>
              <p className="mt-1 text-[13px] font-extrabold uppercase tracking-wider text-ink" data-id="element-207" data-mp="2iezew9zwj2cw">One-time payment</p>
            </div>

            <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-208" data-mp="2necbhmgkrnso">
              {perks.map(p => <li key={p} className="flex items-center gap-2 text-[15px] font-semibold" data-id="element-209" data-mp="29fcoej8pngym">
                  <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden data-id="element-210" data-mp="2df4sain5syxn" />
                  {p}
                </li>)}
            </ul>

            <CTAButton className="mt-7" label="Get the Atlas™ for $27" data-id="element-211" data-mp="7l3pui1xh6jx" />
            <p className="mt-4 flex items-center justify-center gap-1.5 text-center text-[13px] text-muted" data-id="element-212" data-mp="bnqk0pm2n3ka">
              <LockIcon className="h-3.5 w-3.5" aria-hidden data-id="element-213" data-mp="1w4hkym2co8hk" />
              Secure checkout · Instant digital access · 7-day guarantee
            </p>
          </div>
        </div>

        <p className="mt-6 text-center text-[15px] leading-relaxed text-white/75" data-id="element-214" data-mp="25xyerq2hlnl8">
          For less than the cost of many professional educational resources, you’ll have a structured revision-case review
          system you can return to whenever you need to study a difficult liposuction case.
        </p>

        <OfferUrgency dark data-id="element-215" data-mp="2av6znyf0s5q6" />
      </div>
    </section>;
}